import { Routes } from '@angular/router';

import { EventPageResolver } from '@core/resolvers/event-page.resolver';
import { PageBuilderSmartComponent } from './page-builder-smart.component';
import { pageResolver } from '@core/resolvers/page.resolver';
import { resolveCalendarPage } from '@core/resolvers/calendar-page.resolver';
import { TagPageResolver } from '@core/resolvers/tag-page.resolver';

export const eventRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':eventId',
        resolve: {
          pageScope: EventPageResolver,
        },
        children: [
          {
            path: '',
            component: PageBuilderSmartComponent,
          },
          {
            path: 'tickets/:ticketId',
            loadComponent: () =>
              import('../event/tickets/ticket-page.component').then(
                (c) => c.TicketPageComponent
              ),
          },
        ],
      },
    ],
  },
];

export const tagRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: ':tagSlug',
        resolve: { pageScope: TagPageResolver },
        component: PageBuilderSmartComponent,
      },
    ],
  },
];

export const calendarRoute: Routes = [
  {
    path: '',
    resolve: { pageScope: resolveCalendarPage },
    component: PageBuilderSmartComponent,
  },
];

export const dynamicPageRoutes: Routes = [
  {
    path: ':pageId',
    resolve: { pageScope: pageResolver },
    component: PageBuilderSmartComponent,
  },
];
